{
  "name": "croisi-boat-player-front",
  "version": "1.4.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --port 4203",
    "start:prod": "ng serve --port 4203 --configuration production",
    "offline": "ng build && pnpm dlx http-server -p 4299 -c-1 dist/croisi-boat-player-front/browser",
    "build": "ng build && pnpm run sentry:sourcemaps",
    "build:preprod": "ng build --configuration preprod",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "preinstall": "npx only-allow pnpm",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org croisieurope --project croisi- ./dist && sentry-cli sourcemaps upload --org croisieurope --project croisi-boat-player-front ./dist"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.0.3",
    "@angular/common": "^21.0.3",
    "@angular/compiler": "^21.0.3",
    "@angular/core": "^21.0.3",
    "@angular/forms": "^21.0.3",
    "@angular/platform-browser": "^21.0.3",
    "@angular/router": "^21.0.3",
    "@jsverse/transloco": "^7.6.1",
    "@jsverse/transloco-locale": "^7.0.1",
    "@jsverse/transloco-utils": "^7.0.2",
    "@sentry/angular": "^10.30.0",
    "@sentry/cli": "^2.45.0",
    "@tailwindcss/postcss": "^4.1.16",
    "@types/ramda": "^0.31.1",
    "dexie": "^4.2.1",
    "postcss": "^8.5.6",
    "ramda": "^0.32.0",
    "rxjs": "~7.8.0",
    "tailwindcss": "^4.1.16",
    "tslib": "^2.3.0",
    "zod": "^4.1.12"
  },
  "devDependencies": {
    "@angular/build": "^21.0.2",
    "@angular/cli": "^21.0.2",
    "@angular/compiler-cli": "^21.0.3",
    "@eslint/js": "^9.38.0",
    "@types/jasmine": "~5.1.0",
    "angular-eslint": "^20.4.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.4",
    "eslint-plugin-unused-imports": "^4.3.0",
    "jasmine-core": "~5.9.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "postcss": "^8.5.3",
    "prettier": "^3.6.2",
    "prettier-eslint": "^16.4.2",
    "typescript": "~5.9.2",
    "typescript-eslint": "^8.46.2"
  }
}
